import { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import { Col, Row } from "reactstrap";

import { Btn, H1, Image } from "../../AbstractElements";

import { dynamicImage } from "../../Service";

import Loader from "../../CommonElements/Loader/Loader";

import { Href } from "../../utils/Constant";

import { encryptData } from "../../utils/helper/Crypto";

import {
  LoginFormPropsType,
  LoginForminitialValues,
} from "../../Type/Forms/FormsType";

import { Formik, Field, Form, ErrorMessage } from "formik";

import * as Yup from "yup";

import { useLoginService } from "../../Service/Authentication/LoginService";

const Login = () => {
  const [FormFieldData] = useState<any>(null);

  const { doLogin, loading } = useLoginService();

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    debugger;

    const params = new URLSearchParams(location.search);

    const username = params.get("username");

    const password = params.get("password");

    if (!username || !password) return;

    const login = async () => {
      try {
        const res = await doLogin({
          procName: "SolidityLogin",

          Para: `{"UserId":"${username}","Password":"${password}"}`,
        });

        if (!res) return;

        if (res[0]?.StatusCode === "1") {
          localStorage.setItem(
            "clientId",
            encryptData(res[0]?.UserId?.toString())
          );

          localStorage.setItem("userToken", encryptData(res[0]?.UserToken));

          localStorage.setItem("UserName", res[0]?.UserName);

          localStorage.setItem("refURL", res[0]?.ReferralURL);

          localStorage.setItem("MemberName", res[0]?.MemberName);

          localStorage.setItem("ProfilePic", res[0]?.ProfilePic);

          localStorage.setItem("LastLoginDate", res[0]?.LastLoginDate);

          setTimeout(() => {
            navigate(`${import.meta.env.BASE_URL}/dashboard`);
          }, 1000);
        } else {
          toast.error(res[0]?.msg);
        }
      } catch (err) {
        console.error("Login error:", err);

        toast.error("Something went wrong!");
      }
    };

    login();
  }, [location, navigate]);

  const LoginSchema = Yup.object().shape({
    userid: Yup.string().required("Username is required"),

    password: Yup.string().required("Password is required"),
  });

  const SimpleLoginHandle = async (values: LoginFormPropsType) => {
    const { userid, password } = values;

    const res = await doLogin({
      procName: "SolidityLogin",

      Para: '{"UserId":"' + userid + '","Password":"' + password + '"}',
    });

    if (!res) return;

    if (res[0]?.StatusCode == "1") {
      localStorage.setItem("clientId", encryptData(res[0]?.UserId?.toString()));

      localStorage.setItem("userToken", encryptData(res[0]?.UserToken));

      localStorage.setItem("UserName", res[0]?.UserName);

      localStorage.setItem("refURL", res[0]?.ReferralURL);

      localStorage.setItem("MemberName", res[0]?.MemberName);

      localStorage.setItem("ProfilePic", res[0]?.ProfilePic);

      localStorage.setItem("LastLoginDate", res[0]?.LastLoginDate);

      setTimeout(() => {
        navigate(`${import.meta.env.BASE_URL}/dashboard`);
      }, 1000);
    } else {
      toast.error(res[0]?.msg);
    }
  };

  return (
    <div className="login-container">
      {loading && <Loader />}

      <Row className="g-0">
        {/* Left Side - Login Form */}

        <Col
          md="6"
          className="d-flex flex-column justify-content-center align-items-center left-card bg-white"
        >
          <div className="w-100" style={{ maxWidth: "400px" }}>
            <div className="mb-4">
              <Link to={Href}>
                <Image
                  className="img-fluid"
                  src={dynamicImage("login/suknyalogo.png")}
                  style={{ height: "90px" }}
                  alt="logo"
                />
              </Link>
            </div>

            <H1 className="fw-bold mb-2 text-dark">Welcome Back!</H1>

            <p className="text-muted mb-4">
              Please enter your login details below
            </p>

            <Formik
              initialValues={FormFieldData || LoginForminitialValues}
              validationSchema={LoginSchema}
              enableReinitialize
              onSubmit={(values, { setSubmitting }) => {
                SimpleLoginHandle(values);

                setSubmitting(false);
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="mb-3">
                    <Field
                      type="text"
                      name="userid"
                      placeholder="Email"
                      className="form-control rounded-4"
                    />

                    <ErrorMessage
                      name="userid"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>

                  <div className="mb-3">
                    <Field
                      type="password"
                      name="password"
                      placeholder="Password"
                      className="form-control rounded-4"
                    />

                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>

                  {/* <div className="text-end mb-3">
                    <Link
                      to={`${import.meta.env.BASE_URL}/forgotpassword`}
                      className="small text-decoration-none"
                    >
                      Forgot password?
                    </Link>
                  </div> */}

                  <Btn
                    color="dark"
                    block
                    className="w-100 rounded-4 py-2 fw-bold"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Sign in
                  </Btn>

                  {/* <div className="text-center my-3 text-muted">or continue</div>



                  <button

                    type="button"

                    className="btn btn-outline-secondary w-100 rounded-4 d-flex align-items-center justify-content-center gap-2"

                  >

                    <img

                      src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"

                      alt="Google"

                      width="20"

                      height="20"

                    />

                    Log in with Google

                  </button> */}

                  {/* <p className="mt-4 text-center small">
                    Don’t have an account?{" "}
                    <Link to="/register" className="fw-bold">
                      Sign Up
                    </Link>
                  </p> */}
                </Form>
              )}
            </Formik>
          </div>
        </Col>

        {/* Right Side - Illustration */}

        <Col
          md="6"
          className="d-none d-md-flex flex-column justify-content-center align-items-center text-white position-relative right-card"
        >
          <div className="text-center">
            <img
              src={dynamicImage("login/sukanya.png")}
              alt="illustration"
              className="img-fluid"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
